// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Xo3v","label":"Section_label__27hYR","contentWrap":"Section_contentWrap__1zdhA","footer":"Section_footer__1BvS-","footerInner":"Section_footerInner__1Aotw"};